<template>
  <div class="index">
    <div class="title">{{data.title}}</div>
    <div class="brief">
      {{data.brief}}
    </div>
  </div>
</template>


<style scoped>
  .title{
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
  }
  .index {
    padding: 10px;
    box-sizing: border-box;
  }
  .brief{
    font-size: 14px;
    font-size: 10px;
  }
</style>
<script>

import qs from "qs";
import axios from "axios";
import config from "../config/config";

export default {
  data() {
    return {
      data: {},
      num: "",
      token: "",
      id:0,
    };
  },
  mounted() {
    const url = window.location.href.split("=");
    const num = url.length;
    this.id = url[num - 1];
    const token = url[1].split("&");
    this.token = token[0];
    this.fetch();
  },
  methods: {
    change(index) {
      this.timeType = index;
      this.fetch();
    },
    fetch() {
      let aaa = qs.stringify({
        id: this.id,
      });

      axios.defaults.headers["Content-type"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers["token"] = this.token;
      axios
        .post(
          config.url+"api/immediate/message/detail",
          aaa
        )
        .then((res) => {
          this.data = res.data.data;
          console.log(res.data.data, "-=-=-=");
        });
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/detail.vue